import * as _ from 'underscore'

import { ColumnModel } from '../../modules/api/api.models'

import { OpLocation, OpOperator, OpDataTypeInGroup, OpLocationEquipment, OpDevice } from '../../models/core'
import { Enums } from '../../models/common'

import { DATA_TYPE_GROUP_SERVICE_NAME, DataTypeGroupService } from '../data-type'
import { GridService, GRID_SERVICE_NAME } from '../grid'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../user-session'

import { OPERATOR_SERVICE_NAME, OperatorService } from './operator.service'


//#region Consts

export const OPERATOR_DEPOSITORY_SERVICE_NAME: string = 'OperatorDepositoryService'
export const OPERATOR_DEPOSITORY_SERVICE_PROVIDER_NAME: string = 'OperatorDepositoryServiceProvider'

//#endregion

export class OperatorDepositoryService {

    //#region Ctor

    constructor(
        private dataTypeGroupService: DataTypeGroupService,
        private gridService: GridService,
        private operatorService: OperatorService,
        private userSessionService: UserSessionService
    ) { }

    //#endregion

    //#region Columns

    public getDepositoryGridColumns(): JQueryPromise<ColumnModel[]> {
        return this.gridService.getColumnModelByCategory(
            Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__CONTENT_GRID_PARAMS,
            Enums.SimaxModuleName.Depository,
            {
                groupReferenceType: Enums.ReferenceType.IdDistributor,
                groupReferenceValue: this.userSessionService.getLoggedOperator().idDistributor,
                viewReferenceType: Enums.ReferenceType.SerialNbr
            }
        )
    }


    //#endregion

    //#region Content

    public getOperatorDepositoryContent(operator: OpOperator): JQueryPromise<OpLocationEquipment[]> {
        return this.userSessionService
            .getDataProvider().Operator
            .getOperatorDepositoryContent(operator.idOperator)
    }

    //#endregion


    //#region Parameters

    public getOperatorDepositoryBasicParametersDataTypeGroup(): JQueryPromise<OpDataTypeInGroup[]> {
        return this.dataTypeGroupService
            .getDataTypeInGroupByCategory(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PANEL_PARAMS_TO_DISPLAY, Enums.SimaxModuleName.Depository, {
                groupReferenceType: Enums.ReferenceType.IdDistributor,
                groupReferenceValue: this.userSessionService.getLoggedOperator().idDistributor
            })
    }

    //#endregion


    //#region Save

    public saveOperatorDepository(operator: OpOperator, depository: OpLocation): JQueryPromise<OpOperator> {
        const newOperator: OpOperator = operator.clone()

        newOperator.opState = Enums.OpChangeState.Modified

        if (operator.actor != null) {
            newOperator.actor = operator.actor.clone()
            newOperator.actor.avatar = null
        }

        newOperator.depositoryLocation = depository

        return this.operatorService.saveOperator(newOperator)
    }

    //#endregion
}

export class OperatorDepositoryServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [
        DATA_TYPE_GROUP_SERVICE_NAME,
        GRID_SERVICE_NAME,
        OPERATOR_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        function (
            dataTypeGroupService: DataTypeGroupService,
            gridService: GridService,
            operatorService: OperatorService,
            userSessionService: UserSessionService
        ) {
            return new OperatorDepositoryService(dataTypeGroupService, gridService, operatorService, userSessionService)
        }]

    //#endregion
} 